import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { errorColor, subtitlesColor } from '@/style-guide/colors'
import { Typography } from 'antd'
const { Text } = Typography
const Container = styled.div`
  grid-area: content;
`

export const TripCost = ({ trip = [], showMinFare }) => {
  let minFare = 0
  let maxFare = 0
  let discount = false
  const fixedDecimal = 0

  const getTripCost = (trip) => {
    let tripCost = ''
    switch (trip.tripPaymentType) {
      case 'free':
        tripCost = 'Free'
        break
      case 'payasyougo':
        tripCost = 'Pay Your Own Way'
        break
      default:
        if (trip.rooms && trip.rooms.length > 0) {
          trip.rooms.forEach((room) => {
            room.variants &&
              room.variants.forEach((variant) => {
                if (!minFare || variant.cost < minFare) {
                  minFare = variant.cost
                }
                if (!maxFare || variant.cost > maxFare) {
                  maxFare = variant.cost
                }
              })
          })
          if (minFare === maxFare || showMinFare) {
            tripCost = `$${minFare}${showMinFare ? '+' : ''}`
          } else {
            tripCost = `$${minFare} ~ ${maxFare}`
          }
        }
    }
    return tripCost
  }
  const getDiscountedPrice = (price, discount) => {
    let calPrice = price
    if (discount.discType === 'amount') {
      calPrice = price > discount.amount ? price - discount.amount : 0
    } else {
      calPrice = parseFloat(price * (1 - discount.amount / 100))
      calPrice = calPrice > 0 ? calPrice : 0
    }
    return calPrice.toFixed(fixedDecimal)
  }

  const getDiscountedCost = () => {
    let tripCost = ''
    const minFareDiscounted = getDiscountedPrice(minFare, discount)
    const maxFareDiscounted = getDiscountedPrice(maxFare, discount)
    if (maxFareDiscounted === minFareDiscounted || showMinFare) {
      tripCost = `$${minFareDiscounted}${showMinFare ? '+' : ''}`
    } else {
      tripCost = `$${minFareDiscounted} ~ ${maxFareDiscounted}`
    }
    return tripCost
  }

  const isValidDiscount = (trip) => {
    if (trip && trip.discounts && trip.discounts.length > 0) {
      trip.discounts.forEach((d) => {
        if (d.expirationDate >= parseInt(moment().format('YYYYMMDD')))
          discount = d
      })
    }
  }

  isValidDiscount(trip)

  return (
    <Container>
      <Text
        weight={showMinFare ? '500' : '700'}
        size={showMinFare ? 15 : 20}
        color={showMinFare ? '' : subtitlesColor}
        style={
          discount
            ? {
                marginLeft: 5,
                textDecoration: 'line-through',
                whiteSpace: 'nowrap',
              }
            : {}
        }
      >
        {getTripCost(trip)}
      </Text>
      {discount && (
        <Text
          size={showMinFare ? 15 : 20}
          color={errorColor}
          style={{ marginLeft: showMinFare ? 10 : 5 }}
        >
          {getDiscountedCost()}
          {showMinFare ? '+' : ''}
        </Text>
      )}
    </Container>
  )
}
